import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import UnitList from '@app/views/ProjectUnit/List';
import { memo } from 'react';

export default memo(
  withIfUser(UnitList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
